import { HD, FULL_HD } from '@bedrock-rdk/constants';
import { makeThemeColor, PRIMARY } from '@tornado-rdk/theme';
import { getFont, FONT } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../../../tornado/utils/style';

export const defaultContext = makeDefaultStylingContext();

export const TITLE_MARGIN_BOTTOM = {
  [HD]: 12,
  [FULL_HD]: 16,
};

export const PADDING_LEFT = {
  [HD]: 80,
  [FULL_HD]: 104,
};

export const colors = {
  title: makeThemeColor(PRIMARY),
};

export const getInitialStyle = (context = defaultContext) => {
  const { screenSize, colorMode } = context;
  const font = getFont(FONT.PARIS_2, screenSize);

  return {
    flex: { direction: 'column' },
    Title: {
      x: PADDING_LEFT[screenSize],
      color: colors.title[colorMode],
      text: {
        ...font,
      },
      flexItem: {
        marginBottom: TITLE_MARGIN_BOTTOM[screenSize],
      },
    },
    Items: {
      flex: { direction: 'column' },
    },
  };
};
